import React from 'react'
import './Aboutme.css'

const Aboutme = () => {
  return (
    <div className='aboutme'>
            <p>
                Hi, I'm Akwolu Innocent Chinweike, a passionate web developer from Nigeria.
            </p>
                <br />
            <p>
                I hold a degree in Civil Engineering from Joseph Sarwuan Tarka University, Makurdi, but my journey into tech began in December 2022. I’ve always loved tackling complex tasks, and coding felt like the perfect challenge.
            </p>
            <br />
            
            <p>
                It started with a desire to learn a digital skill, and after conversations with friends, I decided to dive into programming. My first steps were with Python, but I quickly found my calling in front-end web development. Although the learning curve was steep, I stayed committed.
            </p>

            <br />
            <p>
                In April 2023, I invested in the "Complete Web Development" course by Dr. Angela Yu on Udemy. Shortly after, I also joined the ALX Software Engineering program. Though I had to step back from ALX due to work and resource constraints, the foundation it gave me in C programming significantly boosted my understanding of coding concepts.
            </p>
            <br />
            <p>
                Since then, I’ve balanced learning and building projects in both front-end and back-end development. I’m excited to continue growing in this field and applying my skills to real-world projects.
            </p>
            <br />
            <h4>Expertise and Skills</h4>
            <p>
                I’m proficient in JavaScript, React, Node.js, and MongoDB, with hands-on experience in developing both front-end and back-end systems. <br />
                My focus is on crafting clean, user-friendly interfaces and delivering seamless user experiences.
            </p>
                <br /><br />
            <p>
                Outside of coding, I enjoy exploring new technologies, hanging out with friends, or watching a good movie.
            </p>
            <br />
            <br />
            <a href="https://www.linkedin.com/in/innocent-akwolu-5096a5238/" target='_blank'>
                Feel free to reach out if you're interested  in collaboration or have any exciting projects to discuss.
            </a>

        

    </div>
  )
}

export default Aboutme